module.exports = __webpack_public_path__ + "static/media/dana-didik1.03a07b3e.png";